import './custom_assignments' // Defines ALL (window-)global custom vars/consts: ensure to correctly overwrite below
import { overwriteColors } from './colors_tecget'
import { overwriteCoreuiDeviceIcons, overwriteIcons } from './icons_tecget'

const EXTERNAL_LINKS = ['www.tecget.de', 'service-powerflow.tecget.de']
window.LegacyApp.EXTERNAL_LINKS = EXTERNAL_LINKS

overwriteColors()
overwriteIcons()
overwriteCoreuiDeviceIcons()
